import { useState, useEffect, useCallback } from 'react'
import { supabase } from '../lib/supabase'
import { useTranslation } from '../locales/useTranslation'
import ChargerForm from '../components/chargers/ChargerForm'
import ChargerList from '../components/chargers/ChargerList'

const ChargersPage = ({ session, showToast, setActiveTab, setMapFocus }) => {
  const { t } = useTranslation()
  const [chargers, setChargers] = useState([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)

  const fetchMyChargers = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('chargers')
        .select(`
          *,
          charger_availability (
            id,
            day_of_week,
            start_time,
            end_time
          )
        `)
        .eq('owner_id', session.user.id)
        .order('created_at', { ascending: false })

      if (error) throw error
      setChargers(data || [])
    } catch (error) {
      showToast(t('fout'), true)
    } finally {
      setLoading(false)
    }
  }, [session.user.id, showToast, t])

  useEffect(() => { fetchMyChargers() }, [fetchMyChargers])

  const handleChargerAdded = () => {
    setShowForm(false)
    fetchMyChargers()
    showToast(t('laadpaal_opgeslagen'))
  }

  const handleToggleAvailable = async (charger) => {
    try {
      const { error } = await supabase
        .from('chargers')
        .update({ is_available: !charger.is_available })
        .eq('id', charger.id)

      if (error) throw error
      fetchMyChargers()
      showToast(
        charger.is_available
          ? 'Laadpaal offline gezet'
          : 'Laadpaal online gezet ✅'
      )
    } catch (error) {
      showToast(t('fout'), true)
    }
  }

  const handleViewOnMap = (charger) => {
    setMapFocus(charger)
    setActiveTab('kaart')
  }

  if (showForm) {
    return (
      <ChargerForm
        session={session}
        onSuccess={handleChargerAdded}
        onCancel={() => setShowForm(false)}
        showToast={showToast}
      />
    )
  }

  return (
    <div style={{
      height: '100%',
      overflowY: 'auto',
      padding: '52px 18px 20px'
    }}>

      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20
      }}>
        <div style={{
          fontFamily: 'Fraunces, serif',
          fontSize: 24,
          fontWeight: 900,
          color: 'var(--ink)'
        }}>
          {t('mijn_laadpalen')}
        </div>
        <button
          onClick={() => setShowForm(true)}
          style={{
            background: 'var(--green)',
            border: 'none',
            borderRadius: 12,
            padding: '9px 16px',
            color: 'white',
            fontWeight: 700,
            cursor: 'pointer',
            fontSize: 13,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontFamily: 'DM Sans, sans-serif'
          }}>
          ⚡ {t('laadpaal_toevoegen_btn')}
        </button>
      </div>

      {loading ? (
        <div style={{
          textAlign: 'center',
          padding: '50px 0',
          color: 'var(--green)',
          fontWeight: 600
        }}>
          {t('laden')}
        </div>
      ) : chargers.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 0' }}>
          <div style={{ fontSize: 52, marginBottom: 14 }}>🔌</div>
          <div style={{
            fontFamily: 'Fraunces, serif',
            fontSize: 18,
            fontWeight: 900,
            color: 'var(--ink)',
            marginBottom: 6
          }}>
            {t('geen_laadpalen_eigen')}
          </div>
          <div style={{
            color: 'var(--ink-muted)',
            fontSize: 14,
            marginBottom: 24
          }}>
            {t('geen_laadpalen_eigen_sub')}
          </div>
          <button
            onClick={() => setShowForm(true)}
            style={{
              background: 'var(--green)',
              border: 'none',
              borderRadius: 14,
              padding: '14px 28px',
              color: 'white',
              fontWeight: 700,
              cursor: 'pointer',
              fontSize: 15,
              fontFamily: 'DM Sans, sans-serif'
            }}>
            ⚡ {t('laadpaal_toevoegen_btn')}
          </button>
        </div>
      ) : (
        <ChargerList
          chargers={chargers}
          onToggleAvailable={handleToggleAvailable}
          onViewOnMap={handleViewOnMap}
        />
      )}
    </div>
  )
}

export default ChargersPage
